import { Subject } from "rxjs/Subject";

export abstract class BaseComponent {

    protected ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * Use this observable to automagically unsubscribe from streams when the component is destroyed
     */
    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}



// WEBPACK FOOTER //
// ./src/core/components/base.component.ts